<template>
  <div id="wrapper" class="page">
    <div id="content-wrapper">
      <div class="container-fluid" style="overflow:auto; min-height: 700px;">

        <div class="row" style="margin-left:1px;">
          <button class="btn btn-info mb-2 mr-2" @click.prevent="createPitchModal">
            <i class="fas fa-plus"></i> Add Pitch Record
          </button>
          &nbsp;
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" size="sm" class="my-0 mt-1">
          </b-pagination>
          <div style="flex-grow: 1" class="text-center"></div>
          <button class="btn btn-success mb-2 mr-3" @click.prevent="exportReport" v-if="pitch_report_read">
            <i class="fas fa-file-excel pr-1"></i> Report
          </button>

        </div>
        <!-- <div class="form-inline" style="width: 100%">
          </div>
           -->
        <div class="row" style="margin-left:1px; height: 45px;">
          <b-form-input class="mr-2 " style="flex-grow: 1; width:1px;" v-model="search"
            placeholder="Search by Agency, Client, Brand, Key Contact, Decision Maker" @keydown.enter.prevent="queryItem"
            size="md" />
          <!-- 
                  <p class="mt-2 mr-2 ml-2">Date filter:</p>
                  <b-form-group class="mb-2">
                  <b-form-select v-model="dateChoice" :options="dateOption" @change="onfilterDateChange"></b-form-select>
                </b-form-group>
                <p class="ml-2 mt-2 mr-2">From date</p>
                <b-form-group class=" mr-2">
                  <my-date-picker v-model="from" placeholder="DD/MM/YYYY"></my-date-picker>
                </b-form-group>
                <p class="mt-2 mr-2">To</p>
                <b-form-group class="mr-2">
                  <my-date-picker  v-model="to" placeholder="DD/MM/YYYY"></my-date-picker>
                </b-form-group> -->

          <button class="btn btn-secondary mb-2 mr-3 ml-2 " style="float:right; height: 37px; width: 93px;"
            @click.prevent="queryItem">
            <b-row> <i class="fas fa-search mt-1 mr-2 ml-3"> </i>
              <p>Search</p>
            </b-row>


          </button>
        </div>
        <div class="row" style="margin-left:1px; height: 45px;">
          <p class="mt-2 mr-2">Outcome: </p>
          <b-form-group class="mb-2 mr-2">
            <b-form-select v-model="filter" :options="optionsOutcome2"></b-form-select>
          </b-form-group>
          <p class="mt-2 mr-2">Production House:</p>
          <b-form-group class="mb-2">
            <b-form-select v-model="optionProductionHouse" class=" pt-0 pb-0" size="md"
              oninvalid="this.setCustomValidity('Please enter Status')" oninput="setCustomValidity('')" required
              @change="queryItem()">
              <b-form-select-option :value=null>All</b-form-select-option>
              <b-form-select-option v-for="item in productionHouseLists" v-bind:key="item.id"
                :value="item.pickListValue">{{ item.pickListValue }}</b-form-select-option>

            </b-form-select>
          </b-form-group>
          <p class="mt-2 mr-2 ml-2">Date filter:</p>
          <b-form-group class="mb-2">
            <b-form-select v-model="dateChoice" :options="dateOption" @change="onfilterDateChange"></b-form-select>
          </b-form-group>
          <p class="ml-2 mt-2 mr-2">From date</p>
          <b-form-group class=" mr-2">
            <my-date-picker v-model="from" placeholder="DD/MM/YYYY"></my-date-picker>
          </b-form-group>
          <p class="mt-2 mr-2">To</p>
          <b-form-group class="mr-2">
            <my-date-picker v-model="to" placeholder="DD/MM/YYYY"></my-date-picker>
          </b-form-group>



        </div>

        <!-- style="overflow-x: scroll; width: 100%"      -->
        <b-table id="my-table" :current-page="currentPage" :per-page="perPage" :filter="filter" @filtered="onFiltered"
          :filter-included-fields="filterOn" bordered head-variant="dark" hover responsive striped small
          table-variant="light" :fields="fieldsPitch" :items="items" thead-class="text-center">
          <!-- <template slot="top-row">
              <td>
                <b-form-select size="sm" v-model="filter" :options="optionsOutcome2"></b-form-select>
              </td>
              <td>
                <b-form-select  v-model="optionProductionHouse"
                      class=" pt-0 pb-0" size="sm" oninvalid="this.setCustomValidity('Please enter Status')"
                      oninput="setCustomValidity('')" required @change="queryItem()">
                      <b-form-select-option :value=null></b-form-select-option>
                      <b-form-select-option v-for="item in productionHouseLists" v-bind:key="item.id"
                        :value="item.pickListValue">{{ item.pickListValue }}</b-form-select-option>
  
                    </b-form-select>
              </td>
              <td>
                <b-form-input  size="sm"  disabled="true"></b-form-input>
             
              </td>
              <td>
                <b-form-input  size="sm"  disabled="true"></b-form-input>
              </td>
              <td>
                <b-form-input  size="sm"  disabled="true"></b-form-input>
              </td>
              <td>
                <b-form-input  size="sm"  disabled="true"></b-form-input>
              </td>
              <td>
                <b-form-input  size="sm"  disabled="true"></b-form-input>
              </td>
              <td>
                <b-form-input  size="sm"  disabled="true"></b-form-input>
              </td>
              <td>
                <b-form-input  size="sm"  disabled="true"></b-form-input>
              </td>
              <td>
                <b-form-input  size="sm"  disabled="true"></b-form-input>
              </td>
              <td>
                <b-form-input  size="sm"  disabled="true"></b-form-input>
              </td>
              <td>
                <b-form-input  size="sm"  disabled="true"></b-form-input>
              </td>
              <td>
                <b-form-input  size="sm"  disabled="true"></b-form-input>
              </td>
              <td>
                <b-form-input  size="sm"  disabled="true"></b-form-input>
              </td>
            </template> -->
          <template v-slot:cell(outcome)="data">
            <div class="text-center">

              <!-- <b-badge v-if="data.item.statusID == '1'" variant="success">Đang Thực Hiện</b-badge> -->
              <b-badge v-if="data.item.outcome == 'In progress'" variant="success">In progress</b-badge>
              <b-badge v-else-if="data.item.outcome == 'Lost'" variant="danger">Lost</b-badge>
              <b-badge style="background-color: purple!important;" v-else-if="data.item.outcome == 'Won'">Won</b-badge>
            </div>
          </template>
          <template v-slot:cell(action)="data">
            <div v-if="data.item.id != -1">
              <div class="float-right">
                <b-link v-if="((pitch_edit && data.item.outcome == 'In progress') || pitch_won_lost)"
                  class="text-primary mr-2" href="#" @click="updateItem(data.item)">
                  <i class="fas fa-pencil-alt"></i>
                </b-link>

                <b-link v-if="pitch_delete" class="text-danger" href="#" @click.prevent="deleteItem(data)">
                  <i class="fas fa-trash"></i>
                </b-link>
              </div>
            </div>
          </template>
          <!-- <template v-slot:cell(recievedDate)="data">
              <span> {{ data.item.recievedDate | moment("DD/MM/YYYY") }} </span>
            </template> -->
          <!-- <template v-slot:cell(price)="data">
              <div v-if="data.item.price != 0">{{ data.item.price | numeral('0,0') }}</div>
              <div v-else></div>
            </template> -->
        </b-table>
      </div>
    </div>
    <b-modal content-class="border-0 p-0" v-model="createModalShow" size="lg" :no-close-on-backdrop="true"
      :no-close-on-esc="true" header-bg-variant="info" header-text-variant="light" hide-footer scrollable>

      <template v-slot:modal-title>
        Add Pitch Record
      </template>
      <!-- <template v-slot:modal-header>
          <P>Add Pitch Record</P>
          <div style="flex-grow: 1" class="text-center"></div>
          <button class="btn btn-secondary mb-2 mr-3 ml-2 " style="float:right; height: 37px; width: 93px;"
                  @click.prevent="queryItem">
                  <b-row>  <i class="fas fa-search mt-1 mr-2 ml-3" > </i><p>Search</p> </b-row>
                
  
                </button>
        </template> -->
      <b-form autocomplete="off" @submit.prevent="submitCreate">
        <b-row>
          <div style="flex-grow: 1" class="text-center"></div>
          <button class="btn btn-info mb-2 mr-3 ml-2 " style="float:right; height: 37px; width: 115px;"
            @click.prevent="openInfoModal()">
            <b-row> <i class="fas fa-book mt-1 mr-2 ml-3"> </i>
              <p>Guideline</p>
            </b-row>


          </button>
        </b-row>
        <b-row>
          <b-col style="margin-bottom: -15px">
            <b-form-group>
              <template v-slot:label> Date <code>*</code> </template>
              <!-- <b-form-input  size="sm" v-model="contract.signingDate" type="date" /> -->
              <my-date-picker v-model="pitch.date"
                placeholder="Please select the date the brief has been received - DD/MM/YYYY" required></my-date-picker>

            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>Production House <code>*</code> </template>
              <b-row>
                <b-col>
                  <b-form-select v-model="pitch.ProductionHouse" placeholder="Please select the Production House"
                    class=" pt-0 pb-0" size="md" oninvalid="this.setCustomValidity('Please enter Status')"
                    oninput="setCustomValidity('')" required>
                    <b-form-select-option :value=null>Please select the Production House</b-form-select-option>
                    <b-form-select-option v-for="item in productionHouseLists" v-bind:key="item.id"
                      :value="item.pickListValue">{{ item.pickListValue }}</b-form-select-option>

                  </b-form-select>
                </b-col>
              </b-row>
              <!-- <b-form-input size="md" list="my-list-id" v-model="pitch.ProductionHouse" placeholder="Please select the Production House" required></b-form-input>
                <datalist id="my-list-id">
                  <option v-for="size in productionHouseLists" v-bind:key="size.id">{{ size.pickListValue }}</option>
                </datalist> -->
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label> Agency <code> * </code>
                <input class="mr-1" type="radio" id="one" value="true" @change="onChangeAgency"
                  v-model="agencyQuestion" />
                <label class="mr-3" for="one">Yes</label>

                <input class="mr-1" type="radio" id="two" value="false" @change="onChangeAgency"
                  v-model="agencyQuestion" />
                <label for="two">No</label> </template>

              <b-form-input v-model="pitch.Agency" class=" pt-0 pb-0" placeholder="Please write down the agency name"
                oninvalid="this.setCustomValidity('Please enter value')" oninput="setCustomValidity('')" size="m"
                :readonly="readonly" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>Client <code>*</code> </template>
              <b-form-input v-model="pitch.Client" id="textarea-auto-height"
                placeholder="Please write down the company / client name and not brand name (e.g. PepsiCo, Unilever, Coke etc.)">
              </b-form-input>

            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>Brand <code>*</code> </template>
              <b-form-input v-model="pitch.Brand" id="textarea-auto-height"
                placeholder="Please write down the brand name">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label> Territory <code>*</code> </template>
              <b-row>
                <b-col>
                  <b-form-select v-model="pitch.Territory" placeholder="Please write down the brand name"
                    class=" pt-0 pb-0" size="md" oninvalid="this.setCustomValidity('Please enter Status')"
                    oninput="setCustomValidity('')" required>
                    <b-form-select-option :value=null>Please select the country of origin</b-form-select-option>
                    <b-form-select-option v-for="item in territoryList" v-bind:key="item.id"
                      :value="item.pickListValue">{{ item.pickListValue }}</b-form-select-option>

                  </b-form-select>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label> Budget <code>*</code> </template>
              <template>
                <b-row>
                  <b-col>
                    <!-- <b-form-input size="md" list="my-list-id" v-model="pitch.BudgetRange" placeholder="Please write the budget range (as per your knowledge)" number="true" required></b-form-input> -->
                    <b-form-input v-model="pitch.BudgetRange" id="textarea-auto-height"
                      placeholder="Please write down the estimated budget" type="number">
                    </b-form-input>
                  </b-col>

                  <p class="mt-2 mr-3">Billion VND</p>


                </b-row>

              </template>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label> Status <code>*</code> </template>
              <b-row>
                <b-col>
                  <b-form-select v-model="pitch.Status" :options="optionsStatus" class=" pt-0 pb-0" size="md"
                    oninvalid="this.setCustomValidity('Please enter Status')" oninput="setCustomValidity('')" required />
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label> Probability <code>*</code> </template>
              <b-row>
                <b-col>
                  <b-form-select v-model="pitch.Probability" :options="optionsProbability" class=" pt-0 pb-0" size="md"
                    oninvalid="this.setCustomValidity('Please enter Status')" oninput="setCustomValidity('')" required />
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>Key Contact <code>*</code> </template>
              <b-form-input v-model="pitch.KeyContact" id="textarea-auto-height"
                placeholder="Please write down the key contact for this pitch (from agency or client side)">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label> Decision Maker <code>* </code>
                <input class="mr-1" type="radio" id="oned" value="true" @change="onChangeDecisionMaker()"
                  v-model="decisionMakerQuestion" />
                <label class="mr-3" for="oned">Yes</label>

                <input class="mr-1" type="radio" id="twod" value="false" @change="onChangeDecisionMaker()"
                  v-model="decisionMakerQuestion" />
                <label for="twod">No</label>
              </template>

              <b-form-input v-model="pitch.DecisionMaker" class=" pt-0 pb-0"
                placeholder="Please write down the name of the decision maker for this pitch (as per your knowledge)"
                oninvalid="this.setCustomValidity('Please enter value')" oninput="setCustomValidity('')" size="m"
                :readonly="readonly2" />
            </b-form-group>
          </b-col>

        </b-row>

        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label> Outcome <code>*</code> </template>
              <b-row>
                <b-col>
                  <b-form-select v-model="pitch.Outcome" @change="onChangeOutcome" :options="optionsOutcome"
                    class=" pt-0 pb-0" size="md" oninvalid="this.setCustomValidity('Please enter Status')"
                    oninput="setCustomValidity('abcccccc')" required />
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="outCome">
          <b-col>
            <b-form-group>
              <template v-slot:label> Reason of Loss <code>*</code> </template>
              <b-row>
                <b-col>
                  <b-form-select v-model="pitch.ReasonOfLoss" class=" pt-0 pb-0" size="md" :options="optionsReason"
                    oninvalid="this.setCustomValidity('Please enter Status')" oninput="setCustomValidity('abcccccc')"
                    required />
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>



        <b-row class="float-right">
          <button class="btn-sm border-0 btn-info mr-3 float-right mb-2" @click.prevent="submitCreate"
            :disabled="isDisabled">
            <i class="fas fa-save mr-2 "></i> Save
          </button>
          <button class="btn-sm border-0 btn-secondary  mb-2 mr-2" @click.prevent="closeCreateModal">
            <i class="fas fa-times mr-2 "></i> Close
          </button>

        </b-row>
      </b-form>

    </b-modal>

    <!-- Modal edit  -->
    <b-modal content-class="border-0 p-0" v-model="editModalShow" size="lg" :no-close-on-backdrop="true"
      :no-close-on-esc="true" header-bg-variant="info" header-text-variant="light" hide-footer scrollable>

      <template v-slot:modal-title>
        Edit Pitch Record
      </template>
      <b-form autocomplete="off" @submit.prevent="submitEdit">
        <b-row>
          <b-col style="margin-bottom: -15px">
            <b-form-group>
              <template v-slot:label> Date <code>*</code> </template>
              <!-- <b-form-input  size="sm" v-model="contract.signingDate" type="date" /> -->
              <my-date-picker v-model="pitch.date"
                placeholder="Please select the date the brief has been received - DD/MM/YYYY"></my-date-picker>

            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>Production House <code>*</code> </template>
              <b-row>
                <b-col>
                  <b-form-select v-model="pitch.ProductionHouse" placeholder="Please select the Production House"
                    class=" pt-0 pb-0" size="md" oninvalid="this.setCustomValidity('Please enter Status')"
                    oninput="setCustomValidity('')" required>
                    <b-form-select-option :value=null>Please select the country of origin</b-form-select-option>
                    <b-form-select-option v-for="item in productionHouseLists" v-bind:key="item.id"
                      :value="item.pickListValue">{{ item.pickListValue }}</b-form-select-option>

                  </b-form-select>
                </b-col>
              </b-row>
              <!-- <b-form-input size="md" list="my-list-id" v-model="pitch.ProductionHouse" placeholder="Please select the Production House" required></b-form-input>
                <datalist id="my-list-id">
                  <option v-for="size in productionHouseLists" v-bind:key="size.id">{{ size.pickListValue }}</option>
                </datalist> -->
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label> Agency <code> * </code>
                <input class="mr-1" type="radio" id="one" value="true" @change="onChangeAgency"
                  v-model="agencyQuestion" />
                <label class="mr-3" for="one">Yes</label>

                <input class="mr-1" type="radio" id="two" value="false" @change="onChangeAgency"
                  v-model="agencyQuestion" />
                <label for="two">No</label> </template>

              <b-form-input v-model="pitch.Agency" class=" pt-0 pb-0" placeholder="Please write down the agency name"
                oninvalid="this.setCustomValidity('Please enter value')" oninput="setCustomValidity('')" size="m"
                :readonly="readonly" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>Client <code>*</code> </template>
              <b-form-input v-model="pitch.Client" id="textarea-auto-height"
                placeholder="Please write down the company / client name and not brand name (e.g. PepsiCo, Unilever, Coke etc.)">
              </b-form-input>

            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>Brand <code>*</code> </template>
              <b-form-input v-model="pitch.Brand" id="textarea-auto-height"
                placeholder="Please write down the brand name">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label> Territory <code>*</code> </template>
              <b-row>
                <b-col>
                  <b-form-select v-model="pitch.Territory" placeholder="Please write down the brand name"
                    class=" pt-0 pb-0" size="md" oninvalid="this.setCustomValidity('Please enter Status')"
                    oninput="setCustomValidity('')" required>
                    <b-form-select-option :value=null>Please select the country of origin</b-form-select-option>
                    <b-form-select-option v-for="item in territoryList" v-bind:key="item.id"
                      :value="item.pickListValue">{{ item.pickListValue }}</b-form-select-option>

                  </b-form-select>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label> Budget <code>*</code> </template>
              <template>
                <b-row>
                  <b-col>
                    <!-- <b-form-input size="md" list="my-list-id" v-model="pitch.BudgetRange" placeholder="Please write the budget range (as per your knowledge)" number="true" required></b-form-input> -->
                    <b-form-input v-model="pitch.BudgetRange" id="textarea-auto-height"
                      placeholder="Please write down the estimated budget" type="number">
                    </b-form-input>
                  </b-col>

                  <p class="mt-2 mr-3">Billion VND</p>


                </b-row>

              </template>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label> Status <code>*</code> </template>
              <b-row>
                <b-col>
                  <b-form-select v-model="pitch.Status" :options="optionsStatus" class=" pt-0 pb-0" size="md"
                    oninvalid="this.setCustomValidity('Please enter Status')" oninput="setCustomValidity('')" required />
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label> Probability <code>*</code> </template>
              <b-row>
                <b-col>
                  <b-form-select v-model="pitch.Probability" :options="optionsProbability" class=" pt-0 pb-0" size="md"
                    oninvalid="this.setCustomValidity('Please enter Status')" oninput="setCustomValidity('')" required />
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>Key Contact <code>*</code> </template>
              <b-form-input v-model="pitch.KeyContact" id="textarea-auto-height"
                placeholder="Please write down the key contact for this pitch (from agency or client side)">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label> Decision Maker <code>* </code>
                <input class="mr-1" type="radio" id="oned" value="true" @change="onChangeDecisionMaker()"
                  v-model="decisionMakerQuestion" />
                <label class="mr-3" for="oned">Yes</label>

                <input class="mr-1" type="radio" id="twod" value="false" @change="onChangeDecisionMaker()"
                  v-model="decisionMakerQuestion" />
                <label for="twod">No</label>
              </template>

              <b-form-input v-model="pitch.DecisionMaker" class=" pt-0 pb-0"
                placeholder="Please write down the name of the decision maker for this pitch (as per your knowledge)"
                oninvalid="this.setCustomValidity('Please enter value')" oninput="setCustomValidity('')" size="m"
                :readonly="readonly2" />
            </b-form-group>
          </b-col>

        </b-row>

        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label> Outcome <code>*</code> </template>
              <b-row>
                <b-col>
                  <b-form-select v-model="pitch.Outcome" @change="onChangeOutcome" :options="optionsOutcome"
                    class=" pt-0 pb-0" size="md" oninvalid="this.setCustomValidity('Please enter Status')"
                    oninput="setCustomValidity('abcccccc')" required />
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="outCome">
          <b-col>
            <b-form-group>
              <template v-slot:label> Reason of Loss <code>*</code> </template>
              <b-row>
                <b-col>
                  <b-form-select v-model="pitch.ReasonOfLoss" class=" pt-0 pb-0" size="md" :options="optionsReason"
                    oninvalid="this.setCustomValidity('Please enter Status')" oninput="setCustomValidity('abcccccc')"
                    required />
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>



        <b-row class="float-right">
          <button class="btn-sm border-0 btn-info mr-3 float-right mb-2" @click.prevent="submitEdit"
            :disabled="isDisabled">
            <i class="fas fa-save mr-2 "></i> Save
          </button>
          <button class="btn-sm border-0 btn-secondary  mb-2 mr-2" @click.prevent="closeEditModal">
            <i class="fas fa-times mr-2 "></i> Close
          </button>

        </b-row>
      </b-form>

    </b-modal>
    <b-modal content-class="border-0 p-0" v-model="guidelineModal" size="lg" :no-close-on-backdrop="true"
      :no-close-on-esc="true" header-bg-variant="info" header-text-variant="light" hide-footer scrollable>
      <template v-slot:modal-title>
        Guideline
      </template>
      <b-table head-variant="light" striped hover :items="listGuideline"></b-table>
    </b-modal>
  </div>
</template>
    
<script>
import axios from "axios";
//import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import MyDatePicker from "../../components/App/DatePickerUS";
// import MyCurrencyInput from "../../components/App/MyCurrencyInput";
export default {
  name: "Assets",
  components: {
    //  MyCurrencyInput,
    //Multiselect,
    MyDatePicker,
  },
  data() {
    return {
      listGuideline: [
        { Information: 'Date', Guideline: 'Please select the date the brief has been received' },
        { Information: 'Production House', Guideline: 'Please select the Production House' },
        { Information: 'Agency', Guideline: 'Please write down the agency name' },
        { Information: 'Client', Guideline: 'Please write down the company / client name and not brand name (e.g. PepsiCo, Coke, Unilever, Nestle, Vinamilk, etc.)' },
        { Information: 'Brand', Guideline: 'Please write down the brand name' },
        { Information: 'Territory', Guideline: 'Please select the country of origin' },
        { Information: 'Budget', Guideline: 'Please write down the estimated budget' },
        { Information: 'Status', Guideline: 'Please select the current status of the pitch:' },
        { Information: '', Guideline: 'Phase 1 (Director scout, Post House scout, Initial timeline);', _rowVariant: 'light' },
        { Information: '', Guideline: 'Phase 2 (Shortlisted, Treatment, Timeline)', _rowVariant: 'light' },
        { Information: '', Guideline: 'Phase 3 (Budgeting, Results)', _rowVariant: 'light' },
        { Information: 'Probability', Guideline: 'Please select the probability to win the pitch (as per your knowledge)', _rowVariant: 'secondary' },
        { Information: 'Key Contact', Guideline: 'Please write down the key contact for this pitch (from agency or client side)', _rowVariant: 'light' },
        { Information: 'Decision Maker', Guideline: 'Please write down the name of the decision maker for this pitch (as per your knowledge)', _rowVariant: 'secondary' },
        { Information: 'Outcome', Guideline: 'Please select the outcome of the pitch', _rowVariant: 'light' },
        { Information: 'Reason', Guideline: 'Please select the main reason of loss', _rowVariant: 'secondary' },
      ],
      optionsStatus: [
        { value: null, text: 'Please select the current status of the pitch' },
        { value: 'Phase 1', text: 'Phase 1 (Director scout, Post House scout, Initial timeline)' },
        { value: 'Phase 2', text: 'Phase 2 (Shortlisted, Treatment, Timeline)' },
        { value: 'Phase 3', text: 'Phase 3 (Budgeting, Results)' },
      ],
      optionsProbability: [
        { value: null, text: 'Please select the current status of the pitch' },
        { value: 'Low', text: 'Low' },
        { value: 'Medium', text: 'Medium' },
        { value: 'High', text: 'High' },
      ],
      optionsOutcome: [
        { value: null, text: 'Please select the outcome of the pitch' },
        { value: 'In progress', text: 'In progress' },
        { value: 'Won', text: 'Won' },
        { value: 'Lost', text: 'Lost' },
      ],
      optionsOutcome2: [
        { value: null, text: 'All' },
        { value: 'In progress', text: 'In progress' },
        { value: 'Won', text: 'Won' },
        { value: 'Lost', text: 'Lost' },
      ],
      dateOption: [
        { value: null, text: 'Customized' },
        { value: 30, text: 'Past 30 days' },
        { value: 90, text: 'Past 90 days' },
        { value: 180, text: 'Past 180 days' },
        { value: 360, text: 'Past 360 days' },

      ],
      optionsReason: [
        { value: null, text: 'Please select the main reason of loss' },
        { value: 'Budget', text: 'Budget' },
        { value: 'Director', text: 'Director' },
        { value: 'Schedule', text: 'Schedule' },
        { value: 'Other', text: 'Other' },
      ],
      fieldsPitch: [
        {
          key: "outcome",
          label: "Outcome",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "70px !important", textAlign: "center" },
        },
        {
          key: "productionHouse",
          label: "Production House",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "50px !important", textAlign: "center" },
        },
        {
          key: "date",
          label: "Date",
          sortable: true,
          // thClass: "align-middle",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "70px !important", textAlign: "center" },
          sortByFormatted: false,

          formatter: 'convertDate',
        },
        {
          key: "createdBy",
          label: "Creator",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "40px !important", textAlign: "center" },
          formatter: 'convertEmail'
        },
        {
          key: "agency",
          label: "Agency",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "100px !important", textAlign: "center" },
          formatter: 'convertAgency',
        },
        {
          key: "client",
          label: "Client",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "100px !important", textAlign: "center" },
        },
        {
          key: "brand",
          label: "Brand",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "100px !important", textAlign: "center" },
        },
        {
          key: "territory",
          label: "Territory",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "70px !important", textAlign: "center" },
        },
        {
          key: "budgetRange",
          label: "Budget",
          sortable: true,
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "70px !important", textAlign: "center" },
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "70px !important", textAlign: "center" },
        },
        {
          key: "probability",
          label: "Probability",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "30px !important", textAlign: "center" },
        },
        {
          key: "keyContact",
          label: "Key Contact",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "150px !important", textAlign: "center" },
        },
        {
          key: "decisionMaker",
          label: "Decision Maker",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "150px !important", textAlign: "center" },
        },

        {
          key: "reasonOfLoss",
          label: "Reason",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "50px !important", textAlign: "center" },
        },
        {
          key: "action",
          label: "",
          tdClass: "text-center",
          thClass: "align-middle",
          // thStyle: {width: "80px !important" , textAlign : "center"},
          thStyle: { width: "50px", textAlign: "center" },
        },
      ],

      agencyQuestion: true,
      decisionMakerQuestion: true,
      pitch: {
        id: 0,
        date: null,
        ProductionHouse: null,
        Agency: null,
        Client: null,
        Brand: null,
        Territory: null,
        BudgetRange: null,
        Status: null,
        Probability: null,
        KeyContact: null,
        DecisionMaker: null,
        Outcome: null,
        ReasonOfLoss: null,
        createdBy: null,
      },
      createModalShow: false,
      editModalShow: false,
      productionHouseLists: [],
      territoryList: [],
      outComeHide: false,
      to: null,
      from: null,
      filter: 'In progress',
      search: null,
      items: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      filterOn: ['outcome', 'productionHouse'],
      //filter: null,
      isDisabled: false,
      query: null,
      dateChoice: null,
      optionProductionHouse: null,
      guidelineModal: false,
      assets: [],



      item_selected_assetId: "",
      modalShow: false,

      employees: [],


      state: "Normal",
      state2: "Normal",
    };
  },

  computed: {
    outCome() {
      return this.outComeHide;
    },
    //Permission Buuton Them Taisan/Them LoaiTaiSan/Them khu vuc
    pitch_won_lost() {
      return this.$store.getters.hasPermission("pitch_won_lost");
    },
    pitch_delete() {
      return this.$store.getters.hasPermission("pitch_delete");
    },
    pitch_edit() {
      return this.$store.getters.hasPermission("pitch_edit");
    },
    pitch_report_read() {
      return this.$store.getters.hasPermission("pitch_report_read");
    },


    readonly() {
      return this.state === 'readonly'
    },
    readonly2() {
      return this.state2 === 'readonly'
    },






  },

  beforeRouteEnter(to, from, next) {
    axios
      .all([
        axios.get("/api/picklist?q=pitch_ProductionHouse"),
        axios.get("/api/picklist?q=pitch_Territory"),

        axios.get("/api/pitchSales/getListPtich", { params: to.query }),

      ])
      .then(
        axios.spread(
          (
            productionHouseList,
            territoryList,

            pitchRecords,

          ) => {
            next((vm) =>
              vm.initData(
                productionHouseList.data,
                territoryList.data,

                pitchRecords.data,

              )
            );
          }
        )
      );
  },

  beforeRouteUpdate(to, from, next) {
    axios
      .get("/api/pitchSales/getListPtich", { params: to.query })
      .then((response) => {

        //  this.$log(response);
        this.items = response.data;
        this.onFiltered(response.data);
        //this.$log(this.items);
        // next();
      })
      .catch((err) => {
        next();
      });
  },
  methods: {
    submitCreate() {
      this.isDisabled = true;
      if (this.pitch.date == null) {
        this.$toast.error("Date is empty !", "Error", {
          timeout: 3000,
        });
        return (this.isDisabled = false);
      }
      const formSubmit = {
        id: this.pitch.id,
        date: this.$convert_string_date_special(this.pitch.date),
        productionHouse: this.pitch.ProductionHouse,
        agency: this.pitch.Agency,
        client: this.pitch.Client,
        brand: this.pitch.Brand,
        territory: this.pitch.Territory,
        budgetRange: this.pitch.BudgetRange,
        status: this.pitch.Status,
        probability: this.pitch.Probability,
        keyContact: this.pitch.KeyContact,
        decisionMaker: this.pitch.DecisionMaker,
        outcome: this.pitch.Outcome,
        reasonOfLoss: this.pitch.ReasonOfLoss,
        createdBy: this.pitch.CreatedBy,
      };
      axios.post("/api/pitchSales/createPitch", formSubmit)
        .then((res) => {
          this.isDisabled = false;
          formSubmit.date = res.data.date;
          this.$log(formSubmit.date);
          formSubmit.id = res.data.id;
          formSubmit.createdBy = res.data.createdBy;
          const pitch_created = this.$copy(formSubmit);
          this.items.unshift(pitch_created);
          this.$toast.success("Create Pitch record successfully !", "Successful", {
            timeout: 3000,
          });
          this.createModalShow = false;
          axios.get(`/api/pitchSales/sentMail?id=${res.data.id}`);
        }
        ).catch((err) => {
          this.isDisabled = false;
          this.$toast.error(err.response.data, "Error", {
            timeout: 3000,
          });
        })
    },
    submitEdit() {
      this.isDisabled = true;
      if (this.pitch.date == null) {
        this.$toast.error("Date is empty !", "Error", {
          timeout: 3000,
        });
        return (this.isDisabled = false);
      }
      const formSubmit = {
        id: this.pitch.id,
        date: this.$convert_string_date_special(this.pitch.date),
        productionHouse: this.pitch.ProductionHouse,
        agency: this.pitch.Agency,
        client: this.pitch.Client,
        brand: this.pitch.Brand,
        territory: this.pitch.Territory,
        budgetRange: this.pitch.BudgetRange + "",
        status: this.pitch.Status,
        probability: this.pitch.Probability,
        keyContact: this.pitch.KeyContact,
        decisionMaker: this.pitch.DecisionMaker,
        outcome: this.pitch.Outcome,
        reasonOfLoss: this.pitch.ReasonOfLoss,
        createdBy: this.pitch.CreatedBy,
      };
      axios.put("/api/pitchSales/updatePitch", formSubmit)
        .then((res) => {
          this.isDisabled = false;
          formSubmit.date = this.$convert_string_date(this.pitch.date);
          formSubmit.createdBy = res.data.mail;
          const pitch_created = this.$copy(formSubmit);
          this.items.splice(this.currentIndex, 1, pitch_created);
          this.$toast.success("Update successfully !", "Successful", {
            timeout: 3000,
          });
          this.editModalShow = false;
          if (res.data.rs == "change") {
            axios.get(`/api/pitchSales/sentMail?id=${formSubmit.id}`);
          }
        }
        ).catch((err) => {
          this.isDisabled = false;
          this.$toast.error(err.response.data, "Error", {
            timeout: 3000,
          });
        })
    },
    closeCreateModal() {
      this.createModalShow = false;
    },
    closeEditModal() {
      this.editModalShow = false;
    },
    onfilterDateChange() {
      if (this.dateChoice != null) {
        this.to = this.$convert_date_string(new Date());
        var result = new Date();
        result.setDate(result.getDate() - this.dateChoice);
        this.from = this.$convert_date_string(result);
      } else {
        this.to = null;
        this.from = null;
      }
    },
    onChangeAgency() {
      if (this.agencyQuestion == "true" || this.agencyQuestion == true) {
        this.state = "normal";
        //this.pitch.Agency = "";
      } else {
        this.state = "readonly";
        this.pitch.Agency = "No Agency/Client Directly";
      }
    },
    onChangeDecisionMaker() {
      if (this.decisionMakerQuestion == "true" || this.decisionMakerQuestion == true) {
        this.state2 = "normal";
        //this.pitch.DecisionMaker = "";
      } else {
        this.state2 = "readonly";
        this.pitch.DecisionMaker = "Unknown";
      }
    },
    onChangeOutcome() {
      if (this.pitch.Outcome == "Lost") {
        this.outComeHide = true;
        this.pitch.ReasonOfLoss = null;
      } else {
        this.outComeHide = false;
      }
    },
    openInfoModal() {
      this.guidelineModal = true;
    },
    closeInfoModal() {
      this.guidelineModal = true;
    },
    createPitchModal() {
      this.pitch.id = 0;
      this.pitch.date = null;
      this.pitch.ProductionHouse = null;
      this.pitch.Agency = "";
      this.pitch.Client = "";
      this.pitch.Brand = "";
      this.pitch.Territory = null;
      this.pitch.BudgetRange = null;
      this.pitch.Status = null;
      this.pitch.Probability = null;
      this.pitch.KeyContact = "";
      this.pitch.DecisionMaker = "";
      this.pitch.Outcome = null;
      this.pitch.ReasonOfLoss = null;
      this.createModalShow = true;
      if (this.pitch.Agency == "No Agency/Client Directly") {
        this.agencyQuestion = false;
      } else {
        this.agencyQuestion = true;
      }
      if (this.pitch.DecisionMaker == "Unknown") {
        this.decisionMakerQuestion = false;
      } else {
        this.decisionMakerQuestion = true;
      }
      if (this.pitch.Outcome == "Lost") {
        this.outComeHide = true;
      } else {
        this.outComeHide = false;
      }
      this.onChangeAgency();
      this.onChangeDecisionMaker();
      this.onChangeOutcome();
    },
    initData(
      productionHouseList,
      territoryList,

      pitchRecords,

    ) {
      this.territoryList = territoryList;
      this.productionHouseLists = productionHouseList;

      this.items = pitchRecords;
      this.onFiltered(pitchRecords);

    },
    convertDate(value) {
      return this.$convert_date_string(value);
    },
    convertAgency(value) {
      if (value == "No Agency/Client Directly") {
        return "No Agency"
      }
      return value;
    },
    convertEmail(value) {
      var strl = value.split("@");
      return strl[0];
    },
    exportReport() {
      //   let params = [
      //     phouse = this.optionProductionHouse,
      //     to = this.to
      // ];
      axios.get(`/api/pitchSales/report/?phouse=${this.optionProductionHouse}&to=${this.$swap_date_format_2(this.to)}&from=${this.$swap_date_format_2(this.from)}&outcome=${this.filter}`, { responseType: 'blob' })
        .then((res) => {
          let filename = res.headers["content-disposition"]
            .split(";")
            .find(function (el) {
              if (el.includes("filename=")) return el;
            })
            .replace("filename=", "")
            .trim();
          const url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.ms-excel;charset=utf-8",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
    },


    updateItem(item) {
      this.currentIndex = this.items.indexOf(item);
      axios.get(`/api/pitchSales/getIndex?id=${item.id}`)
        .then(res => {
          this.pitch.id = res.data.id;
          this.pitch.date = this.$convert_date_string(res.data.date);
          this.pitch.ProductionHouse = res.data.productionHouse;
          this.pitch.Agency = res.data.agency;
          this.pitch.Client = res.data.client;
          this.pitch.Brand = res.data.brand;
          this.pitch.Territory = res.data.territory;
          this.pitch.BudgetRange = res.data.budgetRange;
          this.pitch.Status = res.data.status;
          this.pitch.Probability = res.data.probability;
          this.pitch.KeyContact = res.data.keyContact;
          this.pitch.DecisionMaker = res.data.decisionMaker;
          this.pitch.Outcome = res.data.outcome;
          this.pitch.ReasonOfLoss = res.data.reasonOfLoss;
          this.editModalShow = true;
          if (this.pitch.Agency == "No Agency/Client Directly") {
            this.agencyQuestion = false;
          } else {
            this.agencyQuestion = true;
          }
          if (this.pitch.DecisionMaker == "Unknown") {
            this.decisionMakerQuestion = false;
          } else {
            this.decisionMakerQuestion = true;
          }
          if (this.pitch.Outcome == "Lost") {
            this.outComeHide = true;
          } else {
            this.outComeHide = false;
          }
          this.onChangeAgency();
          this.onChangeDecisionMaker();
          this.onChangeOutcome();

        })
        .catch((err) => {
          this.$toast.error(err.response.data, "ERROR", {
            timeout: 3000,
          });
        });
    },

    deleteItem(data) {
      this.$toast.question("Do you really want to delete this record?", "Warning", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Yes</b></button>",
            (instance, toast) => {
              axios
                .delete(`api/pitchSales/deleteRecord?id=${data.item.id}`)
                .then((res) => {
                  this.items.splice(data.index, 1);
                  this.$toast.success("Delete successfully !", "Successful", {
                    timeout: 3000,
                  });
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Error", {
                    timeout: 3000,
                  });
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>No</button>",
            function (instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    queryItem() {
      let query = Object.assign({}, this.$route.query);
      this.currentPage = 1;
      query.phouse = this.optionProductionHouse;
      query.search = this.search;
      if (this.from != null && this.to != null) {
        query.from = this.$swap_date_format_2(this.from);
        query.to = this.$swap_date_format_2(this.to);
      }
      //this.item = null;

      this.$router.push({ query: query });
    },
  },
};
</script>
    